const baseUrl = "/apps/sso/moas/rest/users/migration";

var myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");

document
  .querySelectorAll(".mo-form input").forEach(box => {    
  box.addEventListener("keypress", function (event) {

    if(event.keyCode==13) {
      moFormSSO();
    }
  })
});

document
  .querySelector("button.mo-sso")
  .addEventListener("click", function (event) {
      moFormSSO();
  });

function moFormSSO() {
  
    document.getElementById("email-error").innerHTML = "";
    document.getElementById("password-error").innerHTML = "";

    // Perform validation
    var username = document.querySelector(
      `input[name='mo-email']`
    ).value;
    var password = document.querySelector(
      `input[name='mo-password']`
    ).value;

    var encodeUsername = encodeURIComponent(username);

    if (document.querySelector('button.mo-sso').classList.contains("mo-sso-not-found")) {
      if (password.trim() === "") {
        document.getElementById("password-error").innerHTML =
          "Password is required";
      } else if (username.trim() === "") {
        document.getElementById("password-error").innerHTML =
          "Email is required";
      } else {
        var raw = `{\n    \"shop\" : \"${window.location.host}\",\n    \"email\" : \"${username}\",\n  \"password\" : \"${password}\"\n}`;

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(baseUrl.concat("/validate/credentials"), requestOptions)
          .then((response) => {
            if (response.status == "401") {
              document.getElementById("password-error").innerHTML =
                "Wrong Credentials";
            } else {
              const modal = document.querySelector(".mo-modal");
              const overlay = document.querySelector(".mo-overlay");

              // open modal event
              openModal(modal, overlay);
            }
          })
          .catch((error) => {
            console.log("error", error);
            return error;
          });
      }
    } else {
      if (username.trim() === "") {
        document.getElementById("email-error").innerHTML =
          "Email is required";
      } else {
        var raw = `{\n    \"shop\" : \"${window.location.host}\",\n    \"email\" : \"${username}\"\n}`;

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(baseUrl.concat("/validate/email"), requestOptions)
          .then((response) => {
            if (response.status === 404) {
              document.getElementById("not-found-error").innerHTML = `Account does not exist, Please <a href="https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_signupmdcim" style="margin: 0px 10px;">click here</a> to register`;
              return null;
            }
            return response.text();
          })
          .then((result) => {
            if (result === null) return; // 404 already handled above

            if (
              /^[\],:{}\s]*$/.test(
                result
                  .replace(/\\["\\\/bfnrtu]/g, "@")
                  .replace(
                    /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                    "]"
                  )
                  .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
              )
            ) {
              if (JSON.parse(result).migrationStatus) {
                window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_loginmdcim&login_hint=${encodeUsername}`;
              } else {
                document
                  .querySelector(".field.mo-password")
                  .removeAttribute("style");
                document
                  .querySelector("a.mo-forgot-password")
                  .removeAttribute("style");
                document.querySelector('button.mo-sso').classList.add("mo-sso-not-found");
              }
            } else {
                document.getElementById("not-found-error").innerHTML = `Account does not exist, Please <a href="https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_signupmdcim" style="margin: 0px 10px;">click here</a> to register`;
            }
          })
          .catch((error) => {
            console.log("error", error);
            return error;
          });
      }
    }
}

document
  .querySelector("button.mo-sso-init")
  .addEventListener("click", function (event) {
    // Perform validation
    var username = document.querySelector(
      `input[name='mo-email']`
    ).value;
    var password = document.querySelector(
      `input[name='mo-password']`
    ).value;

      if (password.trim() === "") {
        document.getElementById("password-error").innerHTML =
          "Password is required";
      } else if (username.trim() === "") {
        document.getElementById("password-error").innerHTML =
          "Email is required";
      } else {
        document.querySelector(`#mo-login-form-xecurify input[name='email']`).value = username;
        document.querySelector(`#mo-login-form-xecurify input[name='password']`).value = password;
        document.querySelector(`#mo-login-form-xecurify input[name='shop']`).value = window.location.host;
        document.querySelector('form#mo-login-form-xecurify').submit();
      }
  });

document
  .querySelector("button.mo-shopify-init")
  .addEventListener("click", function (event) {

        // Perform validation
    var username = document.querySelector(
      `input[name='mo-email']`
    ).value;
    var password = document.querySelector(
      `input[name='mo-password']`
    ).value;

      if (password.trim() === "") {
        document.getElementById("password-error").innerHTML =
          "Password is required";
      } else if (username.trim() === "") {
        document.getElementById("password-error").innerHTML =
          "Email is required";
      } else {
        document.querySelector(`input[name='customer[email]']`).value = username;
        document.querySelector(`input[name='customer[password]']`).value = password;
        document.querySelector('form#customer_login').submit();
      }
    
  })


function openRegisterModal() {
  const modal = document.querySelector(".mo-modal-register");
  const overlay = document.querySelector(".mo-overlay");

  // open modal event
  openModal(modal, overlay);
}

function closeRegisterModal() {
  const modal = document.querySelector(".mo-modal-register");
  const overlay = document.querySelector(".mo-overlay");

  // open modal event
  closeModal(modal, overlay);
}




// open modal function
const openModal = function (modal, overlay) {
  modal.classList.remove("mo-hidden");
  overlay.classList.remove("mo-hidden");
};

// close modal function
const closeModal = function (modal, overlay) {
  modal.classList.add("mo-hidden");
  overlay.classList.add("mo-hidden");
};




document
  .querySelectorAll(".mo-modal-register input").forEach(box => {    
  box.addEventListener("keypress", function (event) {

    if(event.keyCode==13) {
      redirectToIdpRegister();
    }
  })
});

function redirectToIdpRegister() {
  const email = document.querySelector("#mo-RegisterForm-email").value;
  var encodeUsername = encodeURIComponent(email);
  var raw = `{\n    \"shop\" : \"${window.location.host}\",\n    \"email\" : \"${email}\"\n}`;

        var requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(baseUrl.concat("/validate/email"), requestOptions)
          .then((response) => {
            if (response.status === 404) {
              window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_signupmdcim`;
              return null;
            }
            return response.text();
          })
          .then((result) => {
            if (result === null) return; // 404 already handled above
         
            if (
              /^[\],:{}\s]*$/.test(
                result
                  .replace(/\\["\\\/bfnrtu]/g, "@")
                  .replace(
                    /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                    "]"
                  )
                  .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
              )
            ) {
              if (JSON.parse(result).migrationStatus) {
                window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_loginmdcim&login_hint=${encodeUsername}`;
              } else {
                document
                  .querySelector(".field.mo-password")
                  .removeAttribute("style");
                document
                  .querySelector("a.mo-forgot-password")
                  .removeAttribute("style");
                document.querySelector('button.mo-sso').classList.add("mo-sso-not-found");

                document.querySelector(
                  `input[name='mo-email']`
                ).value = email;
                closeRegisterModal();
              }
            } else {
                window.location.href = `https://auth.sonyworld.ae/moas/broker/login/shopify/${window.location.host}/account?idpname=custom_oauth_signupmdcim`;
            }
          })
          .catch((error) => {
            console.log("error", error);
            return error;
          });
}


// captcha JS
    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function delayedExecution() {
        const a = document.getElementById("CustomerEmail");

        const focusinEvent = new Event("focusin", {
            bubbles: true,
            cancelable: true
        });

        await a.dispatchEvent(focusinEvent);
        while (document.getElementById("customer_login").getAttribute("data-cptcha") == null || document.getElementById("customer_login").getAttribute("data-hcaptcha-bound") == null) {
            await delay(10);
        }
        document.getElementById("signInButton").click();
    }

    delayedExecution();